<template>
    <div class="query-response">
        <div v-if="!response" class="no-answer">
            <span>
                Not Answered
            </span>
        </div>
        <div v-for="(resp, index) in response"
            :key="index"
            class="choice answer">
                {{ resp.value }}
        </div>
    </div>
</template>

<script>
import Icons from '../icon'
export default {   
    name: 'query-partial',
    props: {
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
		response: {
			type: Array,
		},
	},
    methods: {
    },
    components: {
        ...Icons
    }
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

.query-response {
    .no-answer {

    }
    .choice {
        // font-weight: 700;
		font-size: 13px;
        text-align: left;
        width: 100%;
        border: unset;
        background-color: unset;
        background-color: #f8f8f8;
        color: #833e93;
        border: 1px solid #eeeeee;
        border-radius: 15px;
        &.answer {
            font-weight: bold;
        }
    }
}
</style>